import router from './index';

export default {
    async route(currentStep) {
        switch(parseInt(currentStep)) {
            case 2:
                await router.push({ name: 'due-second-step' });
                break;
            case 3:
                await router.push({ name: 'due-third-step' });
                break;
            case 4:
                await router.push({ name: 'due-fourth-step' });
                break
            case 5:
                await router.push({ name: 'due-fifth-step' });
                break;
            case 6:
                await router.push({ name: 'due-sixth-step' });
                break;
            case 7:
                await router.push({ name: 'due-seventh-step' });
                break;
            default:
                throw new Error('Invalid step');
        }
    }
};
